import React from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { ReactComponent as HomeSVG } from "go-core/images/svg/home.svg";
import { ReactComponent as EnvelopeSVG } from "go-core/images/svg/message.svg";
import { ReactComponent as TelephoneSvg } from "go-core/images/svg/phone.svg";
import { ReactComponent as TaxSVG } from "go-core/images/svg/tax.svg";

interface Props {
	company_email?: string;
	company_street?: string;
	company_zip_code?: string;
	company_build_nr?: string;
	company_city?: string;
	company_phone_number?: string;
	company_tax_id_no?: string;
}

const OrganizationCompanyInfoCard = ({
	company_email,
	company_build_nr,
	company_city,
	company_street,
	company_phone_number,
	company_zip_code,
	company_tax_id_no,
}: Props) => {
	const { t } = useTranslation("admin");

	const drawCompanyAddress = () => {
		let result = "";
		if (company_street) result += `ul. ${company_street}`;
		if (company_build_nr) result += ` ${company_build_nr}`;
		if (company_zip_code) result += `, ${company_zip_code}`;
		if (company_city) result += ` ${company_city}`;
		return result;
	};

	return drawCompanyAddress() ? (
		<Card>
			<Card.Body>
				<h5>{t("common.word.company_info")}</h5>
				{company_tax_id_no && (
					<div className="card-body-item">
						<TaxSVG />
						<span>{company_tax_id_no}</span>
					</div>
				)}
				{drawCompanyAddress() && (
					<div className="card-body-item">
						<HomeSVG />
						<span>{drawCompanyAddress()}</span>
					</div>
				)}
				{company_phone_number && (
					<div className="card-body-item">
						<TelephoneSvg />
						<span>{company_phone_number}</span>
					</div>
				)}
				{company_email && (
					<div className="card-body-item">
						<EnvelopeSVG />
						<span>{company_email}</span>
					</div>
				)}
			</Card.Body>
		</Card>
	) : (
		<></>
	);
};

export default OrganizationCompanyInfoCard;
